import { Box, CircularProgress } from '@mui/material'
import { useProfileRole } from '../hooks/useProfileRole'
import { AthleteProfileEditForm } from '../components/profile/athlete/AthleteProfileEditForm'
import { RecruiterProfileEditForm } from '../components/profile/recruiter/RecruiterProfileEditForm'
import { EmptyStatePanel } from '../components/StatePanel'

/** Single-page edit form for the current user's own profile — no stepper. */
export const ProfileEditPage = () => {
  const { isLoading, isStudent, isRecruiter } = useProfileRole()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    )
  }

  if (isStudent) return <AthleteProfileEditForm />
  if (isRecruiter) return <RecruiterProfileEditForm />

  return (
    <EmptyStatePanel
      title="Profile unavailable"
      description="We couldn't determine your account type. Try refreshing, or contact support if this continues."
    />
  )
}
